import { NgModule } from '@angular/core';
import { WindowRef } from '../common/helpers';
import { ApplicationConfig } from './config';
import { UrlUtil } from './urlutil';

const CONFIG_COMPONENTS = [ApplicationConfig, UrlUtil, WindowRef];

@NgModule({
  providers: [CONFIG_COMPONENTS]
})
export class ConfigModule {}
